// extracted by mini-css-extract-plugin
export default {"root":"Select_root__Nh5B3","nbSelect":"Select_nbSelect__rcECo"};